import { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './actionIcon.module.scss';
import { Typography } from '@mui/material';

const ActionIcon = ({ hasError, Icon, onClick, title, subtitle }) => {
    return (
        <div className={styles.root} onClick={onClick}>
            <button
                className={styles.actionIcon}
                style={{ border: hasError ? '1px solid red' : '' }}>
                <Icon />
            </button>
            <div>
                {title && (
                    <Typography
                        fontSize="18px"
                        fontFamily="InstrumentSans-semibold"
                        sx={{ lineHeight: 'normal', letterSpacing: '-0.36px' }}>
                        {title}
                    </Typography>
                )}
                {subtitle && (
                    <Typography
                        fontSize="13px"
                        color="#6C6C6C"
                        sx={{ lineHeight: 'normal', letterSpacing: '-0.36px' }}>
                        {subtitle}
                    </Typography>
                )}
            </div>
        </div>
    );
};

ActionIcon.propTypes = {
    hasError: PropTypes.bool,
    Icon: PropTypes.elementType,
    onClick: PropTypes.func,
    title: PropTypes.string,
    subtitle: PropTypes.string
};

export default memo(ActionIcon);
